import { createSelector } from "reselect"

import { iGet } from "../../utils/immutable"
import { brandingSelector } from "./selectors"

export const promotionsSelector = createSelector(
  brandingSelector,
  iGet(["content", "promotion"]),
)

const isEnabledInPromotion = service =>
  createSelector(
    brandingSelector,
    iGet(["content", "promotion", service, "enabled"]),
  )

// Curried functions accepting state
export const isRentalCarsPromotionEnabledSelector = isEnabledInPromotion("car_rental")
export const isHotelsPromotionEnabledSelector = isEnabledInPromotion("accommodation")
